import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TaskService {

    constructor(private httpService: HttpService, private http: HttpClient) { }
    getUsersList() {
        if (environment.PSS == true) {
            // return this.http.get(environment.pssUrl + 'userMaster/getAllUsersList/')
            //     .map(res => res.json());

            var request = {
                URL: "userMaster/getAllUsersList/"
            }
            return this.httpService.get(request);


        } else {
            var request = {
                // URL: "userMaster/getUserList/"
                URL: "userMaster/getInternalUserList"
            }
            return this.httpService.getGovEvaCall(request);
            // return this.http.get(environment.clientUrl + 'userMaster/getUserList/')
            //     .map(res => res.json());
        }

    }
    SendImmediateRemainderEmail(parameters) {

        var request = {
            URL: "SendImmediateReminder",
            DATA: parameters
        }
        return this.httpService.post(request);

    }

    updateDocumentIdforActivatedTask(updatedProof) {
        var request = {
            URL: "updateDocumentIDforActivatedTask",
            DATA: updatedProof
        }
        return this.httpService.post(request);
    }

    updateActivatedTask(activatedTask) {
        var request = {
            URL: "updateActivatedTask/" + activatedTask.activatedTaskId,
            DATA: activatedTask
        }
        return this.httpService.post(request);
    }
    deleteTaskfromProcess(processtaskId) {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)
        return this.http.get(environment.pssServerUrl + 'deleteTaskfromProcess/' + processtaskId, { headers: headers })
            .map(res => res);
    }

    getActivatedProcessTaskListByProcessId(processId) {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })
        var request = {
            URL: "getActivatedProcessTaskListByProcessId/" + processId + "/" + libraryTasklistAdmin,
        }
        return this.httpService.get(request);
    }

    getCompanyProcessTaskListByProcessID(processId: string) {
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        // return this.http.get(environment.pssUrl + 'predefinedCompanyProcessTasks/' + processId)
        //     .map(res => res.json());

        var request = {
            URL: "predefinedCompanyProcessTasks/" + processId,
        }
        return this.httpService.get(request);
    }

    getActivatedTaskByTaskId(taskID: string) {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)
        return this.http.get(environment.pssServerUrl + 'activatedTask/' + taskID, { headers: headers })
            .map(res => res);
    }

    sendremindermails(taskid) {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)

        return this.http.post(environment.pssServerUrl + 'notifications6/', taskid, { headers: headers })
            .map(res => res);
    }
    addActivatedTaskstoProcessEmailSend(addActivatedTaskstoProcess) {

        var request = {
            URL: "addActivatedTasksSendEmail/",
            DATA: addActivatedTaskstoProcess
        }
        return this.httpService.post(request);

    }
    getTaskProofFiles(id): Observable<any> {
        const fullUrl = 'getTaskProofData/' + id;
        console.log("📡 Making API call to:", fullUrl);
        return this.httpService.get({ URL: fullUrl });
    }


    downloadTaskProof(id) {
        // var token = localStorage.getItem('token')
        window.location.href = environment.PSSFileNotValidurl + "documentManagement/downloadFileById/" + id;
    }

    removeTaskProof(taskId, documentId, pdfId) {
        var request = {
            URL: "removeTaskProof/" + taskId + "/" + documentId + "/" + pdfId,
        }
        return this.httpService.get(request);
    }
    getTaskCronDetailsById(_id) {
        var editlist = {
            URL: "getTaskCronDetailsById/" + _id,
        }
        return this.httpService.get(editlist);
    }
    getTaskCronDetails() {
        var request = {
            URL: "getCronConfigurations/"
        }
        return this.httpService.get(request);
    }
    deleteCronConfigurations(_id) {
        var request = {
            URL: "deleteCronConfigurations/" + _id,
        }
        return this.httpService.get(request);
    }
    saveCronConfigurations(object) {
        var request = {
            URL: "saveCronConfigurations",
            DATA: object
        }
        return this.httpService.post(request);
    }

    updateCronConfigurations(object) {
        var request = {
            URL: "updateCronConfigurations",
            DATA: object
        }
        return this.httpService.post(request);
    }
    uploadTaskProof(fileData) {
        var request = {
            URL: "activatedTask/uploadTaskProof",
            DATA: fileData
        }
        return this.httpService.post(request);
    }
    updateTaskStatusforMultipleactivatedTasks(activatedTasksData) {

        var request = {
            URL: "updateTaskStatusformultipleTasks/",
            DATA: activatedTasksData
        }
        return this.httpService.post(request);
    }
    getActivatedCompanyTaskListBySearchFilters(searchParameters) {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })

        var request = {
            URL: "activatedCompanyTaskListBySearchFilter/" + libraryTasklistAdmin,
            DATA: searchParameters
        }
        return this.httpService.post(request);
    }
    addActivatedTaskstoProcess(addActivatedTaskstoProcess) {

        var request = {
            URL: "addActivatedTaskstoProcess/",
            DATA: addActivatedTaskstoProcess
        }
        return this.httpService.post(request);

    }

    getActivatedTaskList() {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })

        var request = {
            URL: "activatedTaskList/" + libraryTasklistAdmin
        }
        return this.httpService.get(request);
    }
    sendMeetingTypeAndInvitee(meetingType, inviteeData) {
        var request = {
            URL: "meetingTypeInvitee",
            DATA: { MeetingType: meetingType, Invitee: inviteeData }
        }
        return this.httpService.post(request);
    }

    getCompanyTaskList() {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
        var request = {
            URL: "predefinedCompanyTaskList/"
        }
        return this.httpService.get(request);
    }

    getCompanyTaskListBySearchFilters(searchParameters) {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })

        var request = {
            URL: "predefinedCompanyTaskListBySearchFilter/",
            DATA: searchParameters
        }
        return this.httpService.post(request);
    }
    getAllUsersList() {
        if (environment.PSS == true) {
            // return this.http.get(environment.pssUrl + 'userMaster/getAllUsersList/')
            //     .map(res => res.json());

            var request = {
                URL: "userMaster/getAllUsersList/"
            }
            return this.httpService.get(request);


        } else {
            var request = {
                // URL: "userMaster/getUserList/"
                URL: "userMaster/getAllInternalUserList"
            }
            return this.httpService.getGovEvaCall(request);
            // return this.http.get(environment.clientUrl + 'userMaster/getUserList/')
            //     .map(res => res.json());
        }

    }

    //Created on 2nd oct get company library event based task list
    getCompanyLibraryEventBasedTask(triggerTypeofEventBased, isApproved) {
        console.log('triggerTypeofEventBased', triggerTypeofEventBased);
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })

        var request = {
            URL: "companyLibraryEventBasedTasksList/" + isApproved,
            DATA: { triggerTypeofEventBased: triggerTypeofEventBased }
        }
        return this.httpService.post(request);
    }

    //Created on 2nd oct get company library event based task list
    getCompanyLibraryPeriodicBasedTask(triggerTypeofPeriodicBased, isApproved) {
        console.log('test===========', triggerTypeofPeriodicBased);
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
        var request = {
            URL: "companyLibraryPeriodicBasedTasksList/" + isApproved,
            DATA: { triggerTypeofEventBased: triggerTypeofPeriodicBased }
        }
        return this.httpService.post(request);
    }

    //Created on 18May get company library task list by search filter
    getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParameters, isApproved) {
        var companyid = JSON.parse(localStorage.getItem('companyDetails')).companyID;
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
        var request = {
            // URL: "companyLibraryTaskListBySearchFilter/",
            URL: "companyLibraryTaskList/searchPeriodicTask/dataTable/" + companyid + "/" + isApproved,
            DATA: searchParameters
        }
        return this.httpService.post(request);

    }
    unapproveTaskBeforeDelete(taskId) {
        var request = {
            URL: 'unapproveTaskBeforeDelete/' + taskId
        }
        return this.httpService.get(request);
    }
    deletePredefinedCompanyTask(taskId) {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)


        return this.http.get(environment.pssServerUrl + 'predefinedCompanyTask/' + taskId, { headers: headers })
            .map(res => res);
    }

    addTaskstoProcess(addTaskstoProcess) {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var token = localStorage.getItem('token')
        headers.append("x-access-token", token)
        return this.http.post(environment.pssServerUrl + 'addTaskstoProcess/', JSON.stringify(addTaskstoProcess), { headers: headers })
            .map(res => res);
    }

    //Created on 18May get company library task list by search filter
    getCompanyLibraryTaskListBySearchFilterEventTask(searchParameters, isApproved) {
        var companyid = JSON.parse(localStorage.getItem('companyDetails')).companyID;
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
        var request = {
            // URL: "companyLibraryTaskListBySearchFilter/",
            URL: "companyLibraryTaskList/searchEventTask/dataTable/" + companyid + "/" + isApproved,
            DATA: searchParameters
        }
        return this.httpService.post(request);

    }

    activateCompanyTasks(activateCompanyTasks) {
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        // return this.http.post(environment.pssUrl + 'activateCompanyTasks/', JSON.stringify(activateCompanyTasks), { headers: headers })
        //     .map(res => res.json());

        var request = {
            URL: "activateCompanyTasks",
            DATA: activateCompanyTasks
        }
        return this.httpService.post(request);

    }

    deSelectCompanyTasks(deSelectedTask) {
        var request = {
            URL: "deSelectedTask/",
            DATA: deSelectedTask
        }
        return this.httpService.post(request);
    }

    //created on 19May
    selectCompanyTasks(selectedTask) {
        var request = {
            URL: "selectedTask/",
            DATA: selectedTask
        }
        return this.httpService.post(request);
    }

    //Created on 18May get company library task list
    getCompanyLibraryTaskList() {
        var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "LibraryTaskAll"; })
        var request = {
            URL: "companyLibraryTasksList/"
        }
        return this.httpService.get(request);
    }
    addPeriodicTaskConfiguration(configObject) {
        var request = {
            URL: "addPeriodicTaskConfiguration",
            DATA: configObject
        }
        return this.httpService.post(request);
    }


    updatePeriodicTaskConfiguration(configId, configObject) {
        var request = {
            URL: "updatePeriodicTaskConfiguration/" + configId,
            DATA: configObject
        }
        return this.httpService.post(request);
    }

    getPeriodicTaskConfiguration() {
        var request = {
            URL: "getPeriodicTaskConfiguration/"
        }
        return this.httpService.get(request);
    }

    getTriggerTypeListByTriggerType(triggerType: string) {
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        // return this.http.get(environment.pssUrl + 'taskTriggerTypes/' + triggerType)
        //     .map(res => res.json());

        var request = {
            URL: "taskTriggerTypes/" + triggerType,
        }
        return this.httpService.get(request);
    }
    getDetailsHistory(taskId) {
        var request = {
            URL: 'getTaskHistoryDetails/' + taskId
        }
        return this.httpService.get(request);
    }

    getAllTriggerTypes() {
        var request = {
            URL: 'getAllTriggerTypes'
        }
        return this.httpService.get(request);
    }

    getMeetingTypeList() {
        // return this.http.get(environment.pssUrl + 'meetingType/')
        //     .map(res => res.json());

        var request = {
            URL: "meetingType/"
        }
        return this.httpService.get(request);
    }
    addTask(newTask) {
        var request = {
            URL: "predefinedTask",
            DATA: newTask
        }
        return this.httpService.post(request);
    }

    updateTask(updateTask) {
        var request = {
            URL: "predefinedCompanyTask/" + updateTask.TaskId,
            DATA: updateTask
        }
        return this.httpService.post(request);
    }

    addandActivateTask(newTask) {
        var request = {
            URL: "addandactivatePredefinedTask",
            DATA: newTask
        }
        return this.httpService.post(request);
    }

    updateandActivateTask(updateTask) {
        var request = {
            URL: "updateandactivatePredefinedTask/" + updateTask.TaskId,
            DATA: updateTask
        }
        return this.httpService.post(request);
    }

    getUserDetailsByAssignedUser(userId) {
        var request = {
            URL: "getUserDetailsByAssignedUser/" + userId
        }
        return this.httpService.get(request);
    }

    getTaskTriggersList() {
        // return this.http.get(environment.pssUrl + 'taskTriggerTypes/')
        //     .map(res => res.json());

        var request = {
            URL: "taskTriggerTypes/"
        }
        return this.httpService.get(request);
    }
    updateCompanyTasks(updatedCompanyTasks) {
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        // return this.http.put(environment.pssUrl + 'updatePredefinedCompanyTasks/', JSON.stringify(updatedCompanyTasks), { headers: headers })
        //     .map(res => res.json());

        var request = {
            URL: "updatePredefinedCompanyTasks/",
            DATA: updatedCompanyTasks
        }
        return this.httpService.post(request);

    }

    getPredefinedTaskByTaskId(taskID: string) {

        var request = {
            URL: "predefinedTask/" + taskID
        }
        return this.httpService.get(request);
    }
    getPredefinedCompanyTasksListwithMeetingTypesandTriggerType() {
        // return this.http.get(environment.pssUrl + 'predefinedCompanyTaskListwithMeetingTypesandTriggerType/')
        //     .map(res => res.json());

        var request = {
            URL: "predefinedCompanyTaskListwithMeetingTypesandTriggerType/",
        }
        return this.httpService.get(request);

    }

    approveTask(object) {
        var request = {
            URL: "approveOrRejectTask/",
            DATA: object
        }
        return this.httpService.post(request);
    }

    approveMultipleTask(object121) {
        var request = {
            URL: "approveOrRejectMultipleTask/",
            DATA: object121
        }
        return this.httpService.post(request);
    }

}


